import { toLogin,outLogin,getAccessToken } from "@/utils/login"
import { mapState,mapMutations, mapActions} from 'vuex'
import { SET_USER,SET_HISTORY_KEYWORDS,SET_INS_ID } from "@/store/types"
import {BaseUtil,CONSTANT,Base64Util} from '@zkwq/business'
import { CACHE_KEY,TYPE_FAVLIST,TYPE_COMMENT,MOUDLE_MAME,TYPE_CN_MAP,SYS_LANG_OPTIONS} from "@/constants"
import { Log,GetUser } from "@/api/explore"
export default {
  data(){
    return {
      TYPE_ARTICLE:CONSTANT.TYPE_ARTICLE,
      TYPE_PATENT:CONSTANT.TYPE_PATENT,
      TYPE_REPORT:CONSTANT.TYPE_REPORT,
      TYPE_BOOK:CONSTANT.TYPE_BOOK,
      TYPE_SOFTWARE:CONSTANT.TYPE_SOFTWARE,
      TYPE_PROJECT:CONSTANT.TYPE_PROJECT,
      TYPE_AWARD:CONSTANT.TYPE_AWARD,
      TYPE_SCIENCE_DB:CONSTANT.TYPE_SCIENCE_DB,
      TYPE_FAVLIST:TYPE_FAVLIST,
      TYPE_COMMENT:TYPE_COMMENT,
      MOUDLE_MAME:MOUDLE_MAME,
      TYPE_CN_MAP,
      topicId: "26756bd7d530ff97374ae09ae8a0317a",
      applicationId: '26756bd7d530ff97374ae09ae8a0317a',
      applicationName: "机构知识库前台",
      topic: "机构知识库前台",
      noShowExpert:["83a19d57e88a53966f0a2d2283ecbb28"],
      SYS_LANG_OPTIONS:SYS_LANG_OPTIONS,
      locale: 'zh',
    }
  },
  created () {
    this.locale = this.getLocale()
    if (!this.locale) {
      this.setLocale('zh')
    }
  },
  computed: {
    ...mapState([
        'user','insId','domain','domainMap','historyKeywords'
    ]),
  },
  methods: {
    toLogin,
    ...mapMutations([
      SET_USER,SET_HISTORY_KEYWORDS,SET_INS_ID
    ]),
    ...mapActions([
      SET_INS_ID
    ]),
    setUser(userInfo){
      this[SET_USER](userInfo);
      BaseUtil.setStorage(CACHE_KEY.USER,userInfo);
    },
    outLogin(){
        this[SET_USER](null);
        BaseUtil.removeStorage(CACHE_KEY.USER)
        outLogin();
    },
    str_btoa_bate64(value) {
      //base64 加密
      // let str = encodeURIComponent(value)
      // str = unescape(str)
      // let str64 = window.btoa(str)
      return Base64Util.encode(value);
  },
  goApply(){
      this.$router.push(`/${this.domain}/apply`)
  },
    initLogin(){
      let code = this.$route.query.code;
      if(code){
          getAccessToken(code,(e) => {
            GetUser(e.uid).then(res => {
              if (res.code == 0) {
                e.isJournalAdmin = res?.data?.isJournalAdmin
                e.journalId = res?.data?.journalId
                e.roleList = res?.data?.roleList
              }
              this.setUser(e)
              let targetPath = BaseUtil.getStorage(CACHE_KEY.TARGET_PATH)
              if(targetPath){
                if(targetPath != location.href){
                  location.href = targetPath;
                }
                BaseUtil.removeStorage(CACHE_KEY.TARGET_PATH)
              }else{
                location.href = "/"
              }
            })
          })
      }
    },
    checkLogin(url){
      let showurl = location.href;
      if (url) {
          showurl = url;
      }
      if(!this.user || this.user.anonymous){
        BaseUtil.setStorage(CACHE_KEY.TARGET_PATH, showurl)
        this.toLogin(showurl)
        return false
      }
      return true
    },
    setDocumentTitle (title) {
      if (title) {
        document.title = title + ' - ' + '机构知识库'
      } else {
        document.title = '机构知识云'
      }
    },
    isArrayEmpty (array) {
      return !(array && ((array.length > 0 && array.length !== 1) || (array.length === 1 && array[0] && array[0] !== 'null')))
    },
    arrayContains (array, item) {
      return BaseUtil.isArrayContains(array, item)
    },
    cloneObject (obj) {
      return JSON.parse(JSON.stringify(obj))
    },
    setHistoryKeywords (keywords) {
      this.SET_HISTORY_KEYWORDS(keywords)
    },
    setInsId (insId) {
      this.SET_INS_ID(insId)
      BaseUtil.setStorage(CACHE_KEY.INS_ID,insId);
    },
    setLocale (locale) {
      this.locale = locale
      console.log(this.locale)
      BaseUtil.setStorage('app_locale', locale)
    },
    getLocale () {
      let locale = BaseUtil.getStorage('app_locale')
      if (locale) {
        return locale
      }
      let language = navigator.language || navigator.userLanguage
      if (language) {
        if (language === 'zh-CN') {
          return 'zh'
        } else {
          return 'en'
        }
      }
      return this.locale
    },
    clearHighlight (str) {
      if (!str) {
        return ''
      }
      return str.replace(/<span class="Highlight">/g, '').replace(/<\/span>/g, '')
    },
    goDetail(item){
      this.saveLog({
        event_desc:`浏览-${item.cn_type}-${item.title}`,
        event_params:item,
        event_key:'browse',
      },this.MOUDLE_MAME.FRUIT)
      window.open(this.$router.resolve(`/${this.domain}/microapp/profile/${item.type}/${BaseUtil.AESEncode(item.id)}`).href)
    },
    saveLog(params, module) {
        if(!params.event_key){
            params.event_key = 'operation'
        }
        if(params.event_key == 'browse'){
          params.event_value = "浏览"
        }
        if(params.event_key == 'search'){
          params.event_value = "检索"
        }
        params.application = {
            id: this.insId == 'all'?this.applicationId:this.insId,
            name: this.insId == 'all'?this.applicationName:this.domainMap.get(this.domain).insName+"机构知识库",
            topic: this.topic,
            topicId: this.topicId,
            module: module
        }
        params.user = this.user
        if(!params.url){
            params.url = location.href
        }
        Log(params)
    },
    logBrowse (type, title) {
        let logParams = {
            event_key: 'operation',
            url: location.href,
            user: this.user,
            application: {
            id: this.applicationId,
            name: this.applicationName,
            topic: this.topic,
            topic_id: this.topicId,
            module: MODULE_EXPLORE,
            }
        }
        logParams.event_desc = '浏览详情「' + type + '」「'+title+'」「0000106」'
        Log(logParams)
    },
    
  },
  beforeRouteEnter(to,from,next){
    next(vm => {
      // if(!vm.insId){
      //   if(location.href.replace(/http[s]?(:\/\/)/g,"").substring(location.href.replace(/http[s]?(:\/\/)/g,"").lastIndexOf("/")+1)){
      //     let reg=/(^(http[s]?:\/\/[^\/]*\/)|(^\/))([^\/]+)\/.*$/ig; 
      //     let a=top.location + "/"; 
      //     let domainName =location.host +"/"+a.replace(reg,"$4");
      //     GetInsUuid(domainName).then(e => {
      //       vm.setInsId(e.insUuid)
      //     })
      //   }else{
      //     vm.setInsId("26756bd7d530ff97374ae09ae8a0317a")
      //   }
      // }
      // 通过 `vm` 访问组件实例
      if(to.path.endsWith("/microapp/profile")){
        if(!vm.user || vm.user.name == '匿名用户'){
          vm.toLogin();
        }
      }
      if(to.meta.isNeedLogin){
        if(!vm.user || vm.user.name =='匿名用户' ){
          vm.toLogin();
        }
      }
    })
  }
}